<template>
  <!-- Footer start -->
  <footer class="relative w-full h-full px-4 py-10 bg-[#F7FAFC] lg:py-20">
    <div class="flex flex-col lg:px-8 xl:px-20 max-w-[1400px] sm:max-w-[600px] md:max-w-[900px] lg:max-w-[1400px] mx-auto">
      <!-- Main Row: Logo, Navigation Links, Social Icons -->
      <div class="flex flex-col items-center justify-between w-full gap-6 lg:flex-row">
        <!-- Logo Section -->
        <div class="flex items-center gap-2">
          <!-- <a @click="showMenu = false; this.isScrolled = false;" href="">
            <img v-motion-pop-visible alt="logo" src="@/assets/nav-logo.png" />
          </a> -->
          <a href="#home" class="flex items-center justify-start gap-x-2 sm:gap-x-4"><img v-motion-pop-visible src="@/assets/hanvee-logo.png" class="w-auto h-[52px] object-contain" alt="logo"><h1 v-motion-pop-visible class="text-xl font-extrabold font-lato">HANVEE</h1></a>
        </div>

        <!-- Navigation Links -->
        <div v-motion-pop-visible
          class="flex flex-wrap justify-center gap-4 text-lg font-extrabold text-[#1B1B1B] uppercase lg:flex-nowrap font-lato">
          <a v-for="item in navItems" :key="item.id" :href="`#${item.id}`" :class="[
            'block w-full text-center px-4 py-2  transition-colors lg:inline-block lg:w-auto',
            {
              'font-extrabold text-[#F25960]': activeSection === item.id,
              'text-[#1B1B1B] hover:text-[#252525]': activeSection !== item.id

            }
          ]">
            {{ item.name }}
          </a>

        </div>

        <!-- Social Icons + Copyright -->
        <div class="flex flex-col items-center gap-0">
          <!-- Empty space with consistent height -->
          <p class="h-4 text-sm font-bold font-oxanium" style="visibility: hidden;">
            &nbsp; <!-- Non-breaking space to ensure it renders -->
          </p>

          <!-- Icons Row -->
          <div v-motion-pop-visible class="flex flex-row items-center justify-center gap-1.5">
            <a href="https://www.youtube.com/@HanveeStreamer" target="_blank">
              <img src="@/assets/youtube-footer.png" class="h-[48px] w-[34px]" />
            </a>
            <a href="https://x.com/hanveestake" target="_blank">
              <img src="@/assets/x-footer.png" class="h-[26px] w-[26px]" />
            </a>
            <a href="https://discord.gg/zQ5cGPBuj8" target="_blank">
              <img src="@/assets/discord.png" class="h-[25px] w-[25px] object-contain" />
            </a>
            <a href="https://kick.com/hanvee" target="_blank">
              <img src="@/assets/kick-footer.png" class="h-[25px] w-[25px]" />
            </a>
            <a href="https://t.me/hanveechannel" target="_blank">
              <img src="@/assets/telegram-footer.png" class="h-[25px] w-[25px] object-contain" />
            </a>
          </div>

          <!-- Copyright Text -->
          <p class="text-sm font-bold text-[#1B1B1B] font-oxanium">
            © All rights reserved.
          </p>
        </div>

      </div>

      <!-- Centered Paragraphs Section -->
      <div class="flex flex-col items-center w-full gap-4 px-4 py-4 mt-4 text-base font-normal text-center lg:px-0 font-lato">
        <p class="text-[#1B1B1B]">
          If you ever feel that gambling is becoming a problem, we urge you to
          seek help and support. Most people gamble for fun and enjoyment.
          However, some people think of gambling as a way to make money, spend
          more than they can afford, or use gambling to distract themselves from
          everyday problems.
        </p>
        <p class="text-[#F25960] font-bold font-oxanium">
          To find further advice, help and support visit:
          <span class="underline text-inherit"> <a href=" https://www.begambleaware.org/" target="_blank">
              https://www.begambleaware.org/
            </a></span>
        </p>
        <p class="text-[#1B1B1B]">
          We do not take responsibility for misunderstood promotions, losses
          from gambling in casinos or betting on sites which are linked to or
          promoted on this website. Make sure it is legal for you to use each
          site inside your jurisdiction and ALWAYS gamble responsibly!
        </p>
      </div>
    </div>
  </footer>
  <!-- Footer end -->
</template>


<script>
export default {
  name: 'FooterElement',
  props: {
    activeSection: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      navItems: [
        { id: 'home', name: 'Home' },
        { id: 'socials', name: 'Socials' },
        { id: 'leaderboards', name: 'Leaderboards' },
        { id: 'promotions', name: 'Promotions' },
      ]
    };
  },
}
</script>